import React, { Component, Fragment } from 'react'

import * as ROUTES from 'config/routes'

import { Link, withRouter } from 'react-router-dom'
import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Camera SN',
    dataIndex: 'cameraSn',
    render: (name, row) => (
      <Link to={ROUTES.CAMERA_EDIT.replace(':targetClientId', row.clientId).replace(':cameraSn', row.cameraSn)}>
        {name}
      </Link>
    ),
    sorter: (a, b) => a.cameraSn.localeCompare(b.cameraSn)
  },
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Site Id',
    dataIndex: 'siteId',
    sorter: (a, b) => a.siteId.localeCompare(b.siteId)
  },
  {
    title: 'Zone Id',
    dataIndex: 'zoneId',
    sorter: (a, b) => a.zoneId.localeCompare(b.zoneId)
  },
  {
    title: 'Agent Id',
    dataIndex: 'agentId',
    sorter: (a, b) => a.agentId.localeCompare(b.agentId)
  },
  {
    title: 'Endpoint',
    dataIndex: 'endpoint',
    sorter: (a, b) => a.endpoint.localeCompare(b.endpoint)
  }
]

const ListViewCameras = ({ cameras }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {cameras.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {cameras.length} cameras
      </PageContentUnderTitle>
    )}
    <Table dataSource={cameras} columns={columns} pagination={false} />
  </div>
)

export default ListViewCameras



// WEBPACK FOOTER //
// ./src/pages/summary/summary-list/components/list-view-cameras/index.js